import { ALLOWED_EXTERNAL_FONTS } from './fonts';

const INJECTION_MARKER = 'data-lev-mso-font-fallbacks';

const styleReferencesFont = (style: string, family: string) =>
	new RegExp(`font-family\\s*:[^;]*\\b${family.replace(/\s+/g, '\\s+')}\\b`, 'i').test(style);

/** Word cannot download a webfont and substitutes Times New Roman for it, even where a sans-serif
 *  was asked for. It does read the mso-* descriptors off an @font-face it skipped, and consults them
 *  only through its font-substitution path, so a recipient who has the font installed still sees it. */
export const applyOutlookFontFallbacks = (html: string) => {
	const parsed = new DOMParser().parseFromString(html?.trim() ?? '', 'text/html');
	const head = parsed.querySelector('head');

	if (!head || parsed.querySelector(`[${INJECTION_MARKER}]`)) {
		return html;
	}

	const styles = [...parsed.querySelectorAll('[style]')].map(element => element.getAttribute('style') ?? '');
	const usedFonts = ALLOWED_EXTERNAL_FONTS.filter(font =>
		styles.some(style => styleReferencesFont(style, font.family))
	);

	if (usedFonts.length === 0) {
		return html;
	}

	const fontFaces = parsed.createElement('style');
	fontFaces.setAttribute('type', 'text/css');
	fontFaces.setAttribute(INJECTION_MARKER, '');
	fontFaces.textContent = usedFonts
		.map(
			font =>
				`@font-face { font-family: '${font.family}'; mso-font-alt: '${font.msoFontAlt}'; ` +
				`mso-generic-font-family: ${font.msoGenericFontFamily}; }`
		)
		.join('\n');
	head.appendChild(fontFaces);

	return parsed.documentElement.outerHTML.trim();
};
